export enum MeetingType {
  GenEd = 1,
  SHM = 3,  
  IEP = 4, 
  EVL = 5,
  AnnualReview = 98,
  IEPReconvene = 99
}